module.exports = __webpack_public_path__ + "static/img/AC.76a9d87a.svg";